import * as Constants from "../constants";
import * as InitialStates from "../constants/initialStates";

export default function liveFeedbackAnswersReducer(
  state = InitialStates.getInitialLiveFeedbackAnswersState(),
  action
) {
  switch (action?.type) {
    case Constants.SEND_LIVE_FEEDBACK_ANSWERS:
      return {
        ...InitialStates.getInitialLiveFeedbackAnswersState(),
        loading: true,
      };
    case Constants.SEND_LIVE_FEEDBACK_ANSWERS_SUCCESS: {
      return {
        ...InitialStates.getInitialLiveFeedbackAnswersState(),
        answersSentSuccess: true,
      };
    }
    case Constants.SEND_LIVE_FEEDBACK_ANSWERS_ERROR: {
      return {
        ...InitialStates.getInitialLiveFeedbackAnswersState(),
        errorSaving: true,
      };
    }
    default:
      return state;
  }
}
